exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".DebugConsole__debug-console___255dD{position:fixed;top:0;left:0;right:0;height:500px;background-color:hsla(0,0%,100%,.9);padding:40px}.DebugConsole__visible___3_csI{opacity:.2}", "", {"version":3,"sources":["C:/Projects/presspauseplay/edf-power-map/src/ts/app/debug/DebugConsole.scss"],"names":[],"mappings":"AAAA,qCAAe,eAAe,MAAM,OAAO,QAAQ,aAAa,oCAAuC,YAAY,CAAC,+BAAS,UAAW,CAAC","file":"DebugConsole.scss","sourcesContent":[".debug-console{position:fixed;top:0;left:0;right:0;height:500px;background-color:rgba(255,255,255,0.9);padding:40px}.visible{opacity:0.2}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"debug-console": "DebugConsole__debug-console___255dD",
	"debugConsole": "DebugConsole__debug-console___255dD",
	"visible": "DebugConsole__visible___3_csI"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/typings-for-css-modules-loader/lib?{"modules":true,"importLoaders":1,"sourceMap":true,"localIdentName":"[name]__[local]___[hash:base64:5]","camelCase":true,"namedExport":true,"url":false}!./node_modules/sass-loader/lib/loader.js!./src/ts/app/debug/DebugConsole.scss
// module id = 200
// module chunks = 0